'use client';

import { useMemo } from 'react';
import { FaUtensils, FaStore, FaYinYang } from 'react-icons/fa';
import { FaPaintbrush } from 'react-icons/fa6';
import { IconBaseProps, IconType } from 'react-icons/lib';
import { twMerge } from 'tailwind-merge';

import { useStoreCard } from './store-card-context';

const ICONS: Record<string, IconType> = {
  '10000': FaUtensils,
  '11000': FaPaintbrush,
  '12000': FaStore,
  '13000': FaYinYang,
} as const;

export type CategoryIconProps = IconBaseProps & {
  parentCategoryId?: string;
};

export function CategoryIcon({
  className,
  parentCategoryId,
  ...props
}: CategoryIconProps) {
  const { store } = useStoreCard();

  const Icon = useMemo(() => {
    const categoryId = parentCategoryId || store.parentCategoryId;
    return ICONS[categoryId] || null;
  }, [store, parentCategoryId]);

  return (
    <Icon
      className={twMerge('text-store-primary flex size-5 self-end', className)}
      {...props}
    />
  );
}
